import {
    generatePostLoginToken,
    generatePreLoginToken,
} from "../services/chatService.js";
import { IS_LOGIN } from "../../constants.js";
import { requestChat } from "../services/chatService.js";

export function decodeJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
    );
    return JSON.parse(jsonPayload);
}

export function isTokenExpired(token, bufferSeconds = 60) {
    if (!token) return true;
    const { exp } = decodeJwt(token);
    const now = Math.floor(Date.now() / 1000); // current time in seconds
    return exp - now <= bufferSeconds; // true if expired or within buffer
}

export async function refreshToken(corrId) {
    try {
        const requestData = await requestChat();

        if (requestData) {
            console.log(requestData);
            const res = IS_LOGIN
                ? await generatePostLoginToken(requestData.correlation_id)
                : await generatePreLoginToken(requestData.correlation_id);

            if (!res.ok) {
                throw new Error("Failed to refresh token");
            }

            const data = await res.json();
            console.log(data);

            return data;
        }
    } catch (err) {
        console.error("❌ Refresh token failed", err);
        // You might want to logout here
        return null;
    }
}
